import React from 'react';
import { images } from '../mock';

const About = ({ t }) => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-grid">
          <div className="about-image">
            <div className="about-image-container">
              <img src={images.about} alt="Emma - Your AI Partner" />
              <div className="about-image-glow" />
            </div>
          </div>

          <div className="about-content">
            <h2 className="heading-1">{t.about.title}</h2>
            <p className="heading-3 text-secondary about-subtitle">{t.about.subtitle}</p>
            <p className="body-large">{t.about.description}</p>
            
            <div className="about-stats">
              {(Array.isArray(t.about.stats) ? t.about.stats : []).map((stat, index) => (
                <div key={index} className="stat-item" data-testid={`about-stat-${index}`}>
                  <div className="stat-value heading-hero">{stat.value}</div>
                  <div className="stat-label body-small">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
